// API base url
import CryptoJS from "crypto-js";

export const Apiurl = () => {
  // return "https://edapi.elitewebdemo.com";  
  return "https://cloudapi.shopsaverz.com";      
};

// remove user session
export const RemoveSession = (navigate) => {
  localStorage.clear();
  navigate("/");
};

export const stringifyData = (item) => {
  return JSON.stringify(item);
};

export const parseData = (item) => {
  return JSON.parse(item);
};

// set stringify data to ls
export const SetLocalStorageStringify = (item, value) => {
  localStorage.setItem(item, JSON.stringify(value));
};

// get and parse data from ls
export const GetLocalStorageParsed = (item) => {
  return JSON.parse(localStorage.getItem(item)) || null;
};

// remove from ls
export const RemoveLocalStorage = (item) => {
  return localStorage.removeItem(item);
  
};

export const goToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

//  clear local storage
export const ClearLocalStorage = () => {
  return localStorage.clear();
};

// pages/api/createOrder.js
export const secretKey = () => {
  return "aman_1234";
};

export const Encryption = (item) => {
  const encryptedId = CryptoJS.AES.encrypt(
    item?.toString(),
    secretKey()
  ).toString();

  const shortEncryptedId = encodeURIComponent(encryptedId); 
  return shortEncryptedId;
};

export const EncryptionText = (item) => {
  if (!item) return "";

  const key = secretKey();
  if (!key) throw new Error("Missing encryption key");
  const encryptedId = CryptoJS.AES.encrypt(
    item.toString(),
    key
  ).toString();

  return encodeURIComponent(encryptedId);
};



export const loadRazorpay = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};
